/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import Label from "../../components/label";
import { useHistory } from "react-router-dom";
import appRoute from "../../routes/appRoutes";
import InputMask from "react-input-mask";
// import { useStripe } from '@stripe/react-stripe-js';

const EditBankDetailForm = props => {
  // const history = useHistory();  
  // const formik = useFormik({
  //   initialValues: {
  //     bsbNo: "",
  //     bankName: "",
  //     acNo: "",
  //     acHolderName: ""
  //   },
  //   validationSchema: Yup.object({
  //     bsbNo: Yup.string().required("This field is required"),
  //     bankName: Yup.string().required("This field is required"),
  //     acNo: Yup.string().required("This field is required"),
  //     acHolderName: Yup.string().required("This field is required")
  //   }),
  //   onSubmit: values => {
  //     props.onFormSubmit(values);
  //   }
  // });

  const history = useHistory();
  // const stripe = useStripe();

  const formik = useFormik({
    initialValues: {
      routing_number: "",
      bankName: "",
      account_number: "",
      account_holder_name: "",
    },
    validationSchema: Yup.object({
      // routing_number: Yup.string().required("This field is required"),
      routing_number: Yup.string()
        .matches(/([0-9]{3}(-)[0-9]{3})/, 'Please enter correct BSB Number')
        .required("This field is required"),
      bankName: Yup.string().required("This field is required"),
      account_number: Yup.string().required("This field is required"),
      account_holder_name: Yup.string().required("This field is required")
    }),
    onSubmit: values => {
      // stripe.createToken('bank_account', {
      //   country: 'AU',
      //   currency: 'aud',
      //   routing_number: (values.routing_number).replace('-', ''),
      //   account_number: values.account_number,
      //   account_holder_name: values.account_holder_name,
      //   account_holder_type: 'individual',
      // }).then((result) => {
      //   if (result.error)
      //     props.openStripeModel(result.error.message);
      //   else if (result.token) {
          let formData = {};
          formData["bankAccountNumber"] = values.account_number;
          formData["bankName"] = values.bankName;
          formData["bankAccountName"] = values.account_holder_name;
          formData["bankBSBNumber"] = (values.routing_number).replace('-', '');
          // formData["stripeToken"] = result.token.id;

          formData['routing_number'] = (values.routing_number).replace('-', '');
          formData['account_number'] = values.account_number;
          formData['account_holder_name'] = values.account_holder_name;
          formData['account_holder_type'] = 'individual';

          props.onFormSubmit(formData);
        // }  

      // }).catch((err) => {
      //   console.log("Stripe error : ", err);
      // });
      // props.onFormSubmit(values);
    }
  });

  const gotoBankDetail = () => {
    history.push(appRoute.bankDetails);
  };

  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <Label className="gray small" title="BSB Number" required={true} />
          {/* <ICInput
            id="bsbNo"
            name="bsbNo"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.bsbNo}
            error={formik.touched.bsbNo && formik.errors.bsbNo ? true : false}
            helperText={
              formik.touched.bsbNo && formik.errors.bsbNo
                ? formik.errors.bsbNo
                : ""
            }
          /> */}
          <InputMask
            mask="999-999"
            value={formik.values.routing_number}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.routing_number}
            error={formik.touched.routing_number && formik.errors.routing_number ? true : false}
            helperText={
              formik.touched.routing_number && formik.errors.routing_number
                ? formik.errors.routing_number
                : ""
            }
          >
            {inputProps => (
              <ICInput
                id="routing_number"
                name="routing_number"
                label=""
                placeholder=""
                {...inputProps}
              />
            )}
          </InputMask>
        </div>
        <div className="col-sm-6">
          <Label className="gray small" title="Bank Name" required={true} />
          <ICInput
            id="bankName"
            name="bankName"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.bankName}
            error={
              formik.touched.bankName && formik.errors.bankName ? true : false
            }
            helperText={
              formik.touched.bankName && formik.errors.bankName
                ? formik.errors.bankName
                : ""
            }
          />
        </div>
        <div className="col-sm-6 mt-3">
          <Label
            className="gray small"
            title="Account Number"
            required={true}
          />
          {/* <ICInput
            id="acNo"
            name="acNo"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.acNo}
            error={formik.touched.acNo && formik.errors.acNo ? true : false}
            helperText={
              formik.touched.acNo && formik.errors.acNo
                ? formik.errors.acNo
                : ""
            }
          /> */}
          <ICInput
            id="account_number"
            name="account_number"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.account_number}
            error={formik.touched.account_number && formik.errors.account_number ? true : false}
            helperText={
              formik.touched.account_number && formik.errors.account_number
                ? formik.errors.account_number
                : ""
            }
          />
        </div>
        <div className="col-sm-6 mt-3">
          <Label
            className="gray small"
            title="Account Holder Name"
            required={true}
          />
          {/* <ICInput
            id="acHolderName"
            name="acHolderName"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.acHolderName}
            error={
              formik.touched.acHolderName && formik.errors.acHolderName
                ? true
                : false
            }
            helperText={
              formik.touched.acHolderName && formik.errors.acHolderName
                ? formik.errors.acHolderName
                : ""
            }
          /> */}
          <ICInput
            id="account_holder_name"
            name="account_holder_name"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.account_holder_name}
            error={
              formik.touched.account_holder_name && formik.errors.account_holder_name
                ? true
                : false
            }
            helperText={
              formik.touched.account_holder_name && formik.errors.account_holder_name
                ? formik.errors.account_holder_name
                : ""
            }
          />
        </div>
      </div>

      <div className="row mt-4 mb-3">
        <div className="col-sm-12 text-center mt-5 ">
          <Button type="submit" className="" />
          <Button
            type="button"
            title="Cancel"
            className="ml-3 gray-outline"
            clickEvent={gotoBankDetail}
          />
        </div>
      </div>
    </form>
  );
};

export default EditBankDetailForm;

EditBankDetailForm.defaultProps = {
  serverErrorMsg: ""
};

EditBankDetailForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
